<div class="flex flex-col items-center justify-center min-h-[calc(100vh-200px)] p-4">
  <div class="bg-white p-8 md:p-12 rounded-2xl shadow-xl max-w-lg w-full text-center border-4 border-[var(--black)]">
    <div class="mb-6">
      <svg class="w-20 h-20 text-green-500 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    </div>
    <h1 class="text-3xl md:text-4xl font-bold text-[var(--dark-orange)] mb-4">{{ 'paymentSuccess.title' | translate }}</h1>
    <p class="text-gray-700 text-lg mb-2">{{ 'paymentSuccess.thanks' | translate }}</p>
    <p *ngIf="reservationLocator" class="text-gray-600 mb-8">
      {{ 'paymentSuccess.locator' | translate }} <span class="font-semibold text-[var(--black)]">{{ reservationLocator }}</span>
    </p>
    <div *ngIf="reservationLocator" class="mt-8">
      <app-button [text]="'paymentSuccess.viewDetails' | translate" (click)="goToReservationDetails()" [styleType]="'primary-flat'" [fullWidth]="true"></app-button>
    </div>
    <div class="mt-4">
      <a routerLink="/" class="text-[var(--secondary)] hover:underline font-medium">
        {{ 'paymentSuccess.backHome' | translate }}
      </a>
    </div>
  </div>
</div>
